export default function isError(status) {
  return status === 'error' || status >= 400;
}
